import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { TickmillAppIcon } from '../../../../icons/TickmillAppIcon'
import { detectIOSOperatingSystem } from '../../../../model/PlatformTypeEnum'
import { Text, TextH3 } from '../../../../ui/Typography/Typography'
import { Button } from '../../../button/Button'
import { useMenu } from '../../../context/MenuContext'
import { useProductReadContext } from '../../../context/ProductContext'

import styles from './ActionHubButton.module.scss'

export const ActionHubButton: FC = () => {
  const { t } = useTranslation()
  const { isDefaultCFDProductType } = useProductReadContext()
  const isProductTypeCFD = isDefaultCFDProductType()
  const { closeMenu } = useMenu()

  const handleGetTheAppClick = (e: React.MouseEvent) => {
    e.preventDefault()
    closeMenu()

    if (detectIOSOperatingSystem()) {
      window.open('https://apps.apple.com/app/tickmill/id', '_blank')
    } else {
      window.open('https://play.google.com/store/apps/details?id=com.tickmill', '_blank')
    }
  }

  if (!isProductTypeCFD) {
    return null
  }

  return (
    <div className={styles.actionHubButton}>
      <div className={styles.titleWrapper}>
        <div>
          <TickmillAppIcon />
        </div>
        <div className={styles.title}>
          <TextH3 isParagraph>Tickmill</TextH3>
          <Text className={styles.subtitle}>{t('actionHub.Download the app')}</Text>
        </div>
      </div>
      <Text isParagraph className={styles.body}>
        {t(
          'actionHub.Create accounts, deposit, withdraw and transfer money with Tickmill Mobile App.'
        )}
      </Text>
      <Button size='L' appearance='primary' fullWidth onClick={handleGetTheAppClick}>
        {t('actionHub.Get the app')}
      </Button>
    </div>
  )
}
